"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const CoreContext_1 = require("../../contexts/CoreContext");
const JoinLauncherContext_1 = require("../../contexts/join-launcher/JoinLauncherContext");
const DownloadState_1 = require("../../models/DownloadState");
const Environment_1 = require("../../models/Environment");
const JoinInfo_1 = require("../../models/JoinInfo");
const LaunchType_1 = require("../../models/LaunchType");
const TelemetryEvents_1 = require("../../models/telemetry/TelemetryEvents");
const DownloadService_1 = require("../../services/DownloadService");
const EnvironmentService_1 = require("../../services/EnvironmentService");
const Logger_1 = require("../../services/Logger");
const BusyAnimation_1 = require("../common/v2/BusyAnimation");
const View_1 = require("../common/View");
const AutoDownloader_1 = require("./AutoDownloader");
const JoinMobileView_1 = require("./JoinMobileView");
const JoinView_1 = require("./JoinView");
const Launcher_1 = require("./Launcher");
const ModernMobileView_1 = require("./ModernMobileView");
const ModernViewContainer_1 = require("./ModernViewContainer");
const TflDesktopComingSoonView_1 = require("./TflDesktopComingSoonView");
const UnsupportedView_1 = require("./UnsupportedView");
var ModernViewType;
(function (ModernViewType) {
    ModernViewType[ModernViewType["None"] = 0] = "None";
    ModernViewType[ModernViewType["Meeting"] = 1] = "Meeting";
    ModernViewType[ModernViewType["FreemiumOnboarding"] = 2] = "FreemiumOnboarding";
    ModernViewType[ModernViewType["MobileMeeting"] = 3] = "MobileMeeting";
    ModernViewType[ModernViewType["ShareEmail"] = 4] = "ShareEmail";
})(ModernViewType = exports.ModernViewType || (exports.ModernViewType = {}));
class RootView extends React.Component {
    constructor(props) {
        super(props);
        this.onLaunchClick = () => {
            this.setState((oldState) => {
                return {
                    launcherKey: oldState.launcherKey + 1,
                    launchType: LaunchType_1.LaunchType.OpenApp,
                };
            });
            const event = new TelemetryEvents_1.TryOpenAgainEvent(this.state.joinContext.joinInfo);
            Logger_1.default.log(event);
        };
        this.updateDownloadStep = (newStep) => {
            this.setState((oldState) => {
                const { joinContext } = oldState;
                joinContext.downloadState.step = newStep;
                return { joinContext };
            });
        };
        let downloadKey = 0;
        if (this.props.joinInfo.type === JoinInfo_1.JoinType.FremiumMeeting && this.props.featureFlags.enableFreemiumMeetings === true) {
            downloadKey = this.props.featureFlags.suppressAutoDownload ? 0 : 1;
        }
        this.state = {
            downloadKey,
            launcherKey: this.isPromptSuppressed(),
            joinContext: {
                joinInfo: this.props.joinInfo,
                downloadState: {
                    step: DownloadState_1.DownloadStep.Init,
                    update: this.updateDownloadStep,
                },
            },
            launchType: LaunchType_1.LaunchType.Automatic,
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (props.joinInfo !== state.joinContext.joinInfo) {
            return { joinContext: { joinInfo: props.joinInfo } };
        }
        return null;
    }
    renderView(joinInfo, environment, featureFlags, isModernView, modernViewType) {
        if (environment.os === Environment_1.OperatingSystems.WinPhone) {
            return React.createElement(UnsupportedView_1.UnsupportedView, null);
        }
        switch (environment.deviceType) {
            case Environment_1.DeviceTypes.Mobile:
            case Environment_1.DeviceTypes.Tablet:
                if (featureFlags.enableMobilePage) {
                    return (isModernView && modernViewType === ModernViewType.MobileMeeting ?
                        React.createElement(ModernMobileView_1.ModernMobileView, { onLaunchClick: this.onLaunchClick, launchResult: this.state.launchResult, isTflLink: joinInfo.isTflLink })
                        :
                            React.createElement(JoinMobileView_1.JoinMobileView, { onLaunchClick: this.onLaunchClick }));
                }
            case Environment_1.DeviceTypes.Desktop:
            default:
                if (featureFlags.enableWebJoin && joinInfo.forceWebJoin
                    && environment.isWebClientSupportedBrowser) {
                    const panelViewEvent = new TelemetryEvents_1.PanelViewEvent("join_launcher_loading", joinInfo);
                    Logger_1.default.logUserBiPanelView(panelViewEvent);
                    return (React.createElement(View_1.View, null,
                        React.createElement("div", { className: "centered fillSpace" },
                            React.createElement(BusyAnimation_1.BusyAnimation, { size: "3" }))));
                }
                if (isModernView) {
                    return (React.createElement(ModernViewContainer_1.ModernViewContainer, { onLaunchClick: this.onLaunchClick, launchResult: this.state.launchResult, type: modernViewType }));
                }
                if (featureFlags.enableTflDesktopComingSoon && this.props.joinInfo.isTflLink) {
                    return (React.createElement(TflDesktopComingSoonView_1.TflDesktopComingSoonView, { onLaunchClick: this.onLaunchClick }));
                }
                return (React.createElement(JoinView_1.JoinView, { onLaunchClick: this.onLaunchClick, joinInfo: joinInfo }));
        }
    }
    render() {
        if (!this.state.joinContext.joinInfo.isValid) {
            return null;
        }
        return (React.createElement(JoinLauncherContext_1.JoinLauncherContextProvider, { value: this.state.joinContext },
            React.createElement(CoreContext_1.CoreContextConsumer, null, ({ environment, featureFlags, isModernView, modernViewType, launcherService }) => {
                return (React.createElement("div", { id: this.getRootId(isModernView, modernViewType) },
                    React.createElement(Launcher_1.Launcher, { key: this.state.launcherKey, trigger: !!this.state.launcherKey, launchType: this.state.launchType, featureFlags: featureFlags, environment: environment, joinInfo: this.state.joinContext.joinInfo, launcherService: launcherService, launchResultCallback: (launchResult) => this.launchResultCallback(launchResult) }),
                    React.createElement(AutoDownloader_1.AutoDownloader, { trigger: !!this.state.downloadKey, featureFlags: featureFlags, downloadBehavior: DownloadService_1.default.getDownloadBehaviour(this.state.joinContext.joinInfo, environment, featureFlags, launcherService, this.state.joinContext.downloadState), autoDownloadCallback: () => this.autoDownloadCallback() }),
                    this.renderView(this.state.joinContext.joinInfo, environment, featureFlags, isModernView, modernViewType)));
            })));
    }
    launchResultCallback(launchResult) {
        this.setState({ launchResult });
    }
    autoDownloadCallback() {
        this.setState((oldState) => {
            return { downloadKey: oldState.downloadKey + 1 };
        });
    }
    isPromptSuppressed() {
        // suppress on TfL links on iOS and Safari, because of Safari autolaunch error when app is not installed
        if (this.props.joinInfo.isTflLink
            && this.props.featureFlags.suppressPromptForMobileSafari
            && EnvironmentService_1.default.getOS() === Environment_1.OperatingSystems.iOS
            && EnvironmentService_1.default.getBrowserName() === Environment_1.Browsers.Safari) {
            return 0;
        }
        // supress on TfL meeting link on Desktop
        if (EnvironmentService_1.default.getDeviceType() === Environment_1.DeviceTypes.Desktop &&
            this.props.joinInfo.type === JoinInfo_1.JoinType.MeetupWithCode &&
            this.props.featureFlags.disableTfLDesktop) {
            return 0;
        }
        return this.props.featureFlags.suppressPrompt ? 0 : 1;
    }
    getRootId(isModernView, modernViewType) {
        if (isModernView) {
            return modernViewType === ModernViewType.MobileMeeting ? 'mobileRootViewV2' : 'rootViewV2';
        }
        return 'rootView';
    }
}
exports.RootView = RootView;
